import {namespace} from 'vuex-class';
import {Module} from 'vuex';
import {SET_ALERT_OPTIONS} from '@/store/mutationTypes';
import {RootState} from '@/types';

interface AlertState {
  options: AlertOptions;
}

export type AlertColor =
  | 'primary'
  | 'success'
  | 'warning'
  | 'error'
  | 'secondary'
  | 'info';

export interface AlertOptions {
  color?: AlertColor | string | undefined;
  type?: AlertColor | string | undefined;
  mode?: string;
  show?: boolean;
  text: string;
  dismissable?: boolean;
  icon?: string | undefined;

  [key: string]: any;
}

export const alertModule = namespace('alert');

export default <Module<AlertState, RootState>>{
  namespaced: true,
  state: {
    options: {
      color: undefined,
      type: undefined,
      mode: '',
      show: false,
      text: '',
      dismissable: false,
      icon: undefined,
    },
  },
  mutations: {
    [SET_ALERT_OPTIONS](state, options: AlertOptions) {
      state.options = {...state.options, ...options};
    },
  },
  actions: {
    fire({commit}, options: AlertOptions) {
      commit(SET_ALERT_OPTIONS, options);
    },
    show({commit}, {message, type, options}) {
      commit(SET_ALERT_OPTIONS, {
        show: true,
        text: message,
        type,
        ...options,
      });
    },
    hide({commit}) {
      commit(SET_ALERT_OPTIONS, {
        show: false,
        text: '',
      });
    },
  },
  getters: {},
};
